import { Vue, Component, Prop, Watch } from 'vue-property-decorator'
import { formatDate } from '@/utils/timeFilter'

@Component({
})
export default class CommonLog extends Vue {
  @Prop() logList: []

  formatDate = formatDate
  logShow = true

  created(){
    // console.log(this.logList)
  }
  // @Watch('logList')
  // watchlogList(newVal: any[], old: any[]) {
  //   console.log(newVal, old)
  // }
}
